import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class HelpIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 0a10 10 0 1 1 0 20.002A10 10 0 0 1 10 0zm-.902 14.777h1.93v-1.852h-1.93v1.852zm3.205-8.855a4.015 4.015 0 0 0-2.397-.685 3.36 3.36 0 0 0-1.867.499c-.81.519-1.235 1.38-1.277 2.583H8.63c.002-.366.11-.722.311-1.027A1.15 1.15 0 0 1 10 6.793c.498 0 .84.135 1.027.405.189.263.287.58.28.902.002.28-.085.553-.25.779-.103.144-.23.27-.373.374l-.466.373a2.658 2.658 0 0 0-.872.965c-.147.485-.22.988-.218 1.494h1.744a2.8 2.8 0 0 1 .093-.746c.076-.283.239-.534.467-.717l.467-.343c.348-.246.663-.54.934-.87.28-.412.422-.904.404-1.4a2.364 2.364 0 0 0-.934-2.087z"/></svg>
        )
    }
}

export default withCssClassName(HelpIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/help-icon.js